<mat-card (click)="route()">
  <mat-card-content>
    <h3>{{ headername | translate }}</h3>
    <div class="imgContainer">
      <img src="{{ image }}" />
    </div>
  </mat-card-content>
</mat-card>
